import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Wrench, ShieldCheck } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/Maintenance.css';
const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;
export function useMaintenance() {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    let active = true;
    const check = () => fetch(`${API}/maintenance/status`, {cache: 'no-store'})
      .then(r => { if (!r.ok) throw new Error(); return r.json(); })
      .then(d => { if (active) setEnabled(d.enabled === true); }).catch(() => {});
    check(); const timer = setInterval(check, 15000);
    return () => { active = false; clearInterval(timer); };
  }, []);
  return enabled;
}
export default function MaintenanceNotice() {
  const { lang } = useLanguage(); const nl = lang === 'nl';
  return <section className="maintenance-notice" role="status" data-testid="maintenance-banner">
    <div className="maintenance-art" aria-hidden="true"><span/><span/><span/><Wrench size={30}/></div>
    <span className="maintenance-eyebrow">KRYPTON9 / {nl ? 'PLATFORMONDERHOUD' : 'PLATFORM MAINTENANCE'}</span>
    <h2>{nl ? 'We maken KRYPTON9 nog beter.' : 'Making KRYPTON9 even better.'}</h2>
    <p>{nl ? 'We voeren onderhoud uit. Inloggen en registreren zijn tijdelijk gepauzeerd. Probeer het binnenkort opnieuw. Bedankt voor je geduld.' : 'We are upgrading the platform. Sign-in and registration are temporarily paused. Please check back shortly. Thank you for your patience.'}</p>
    <Link to="/admin?returnTo=portal" data-testid="maintenance-admin-access"><ShieldCheck size={15}/>{nl ? 'Toegang voor beheerders' : 'Administrator access'}</Link>
  </section>;
}
